<div class="card">
  <div class="card-body">
    <h5>{{ 'HOME.AlreadyClientTitle' | labelText }}</h5>
    <div class="buttons-block mb-4">
      <button
        class="btn btn-primary radio-label me-2"
        type="button"
        [ngClass]="{ 'active-btn': (clientType$ | async) === clientType.Contract }"
        (click)="setClientType(clientType.Contract)"
      >
        {{ 'Common.Yes' | labelText }}
      </button>
      <button
        class="btn btn-primary radio-label"
        type="button"
        [ngClass]="{ 'active-btn': (clientType$ | async) === clientType.Prospect }"
        (click)="setClientType(clientType.Prospect)"
      >
        {{ 'Common.No' | labelText }}
      </button>
    </div>
    <p class="txt-default text-center">
      {{ 'HOME.QuestionAlreadyClientHelp' | labelText }}
    </p>
  </div>
</div>
